export default __webpack_public_path__ + "static/media/skyline_salzburg_greenish_02_derived.a5098276.svg";